import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import Button from "../components/Button";
import { loginRequest } from "./msalConfig";
/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const handleLogin = (loginType: string) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e: Error) => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e: Error) => {
        console.log(e);
      });
    }
  };
  return (
    <Button
      width={1}
      as={Link}
      to="/"
      variant="primary"
      onClick={() => handleLogin("redirect")}
    >
      {t("login.ssoButton", "Sign Up / Log In Now")}
    </Button>
  );
};
